module.exports = {"340311001":"淮滨社区","340311002":"明珠社区","340311100":"小蚌埠镇","340311101":"吴小街镇","340311102":"曹老集镇","340311103":"梅桥镇","340311104":"沫河口镇","340311400":"蚌埠工业园区","340311401":"沫河口工业园区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/340311.json
// module id = 1060
// module chunks = 0